import React, { useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
export function Wine() {
  const [activeSection, setActiveSection] = useState('cro');
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Update scrolled state for header
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
      // Only update active section visually without affecting URL or scroll position
      const sections = document.querySelectorAll('.service-section[id]');
      sections.forEach(section => {
        const sectionTop = section.getBoundingClientRect().top;
        const sectionId = section.getAttribute('id');
        if (sectionTop < 200 && sectionTop >= -section.getBoundingClientRect().height + 200) {
          setActiveSection(sectionId);
        }
      });
    };
    window.addEventListener('scroll', handleScroll);
    // Handle initial section display only - no automatic scrolling
    const handleInitialLoad = () => {
      // Set default active section without scrolling
      setActiveSection('cro');
    };
    handleInitialLoad();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);
  const scrollToSection = sectionId => {
    setActiveSection(sectionId);
    // Don't update URL with hash to avoid bounce-back issues
    const element = document.getElementById(sectionId);
    if (element) {
      // Use smooth scrolling for user-initiated navigation
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="min-h-screen bg-[#FAF7F2]" data-id="element-890">
      <Header data-id="element-891" />
      {/* Hero Section - Updated with proper top padding for fixed header */}
      <section className="pt-28 pb-20 px-10" data-id="element-892">
        <div className="max-w-[1400px] mx-auto" data-id="element-893">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-894">
            <div className="grid md:grid-cols-2" data-id="element-895">
              <div className="p-6 md:p-12 lg:p-16 flex flex-col justify-center" data-id="element-896">
                <h1 className="text-[#2C2416] text-[clamp(48px,6vw,64px)] font-light leading-[1.1] tracking-[-3px] mb-6 font-['Inter']" data-id="element-897">
                  Winery Website Design &{' '}
                  <span className="text-[#D4A574]" data-id="element-898">Development</span>
                </h1>
                <p className="text-[#8B7355] text-xl max-w-lg mb-10 leading-relaxed font-['Inter']" data-id="element-899">
                  15 years in wine ecommerce. We design and build on WinePik,
                  Commerce7, WineHub, and Shopify - stores that drive wine club
                  signups and DTC revenue.
                </p>
                <div className="flex flex-wrap gap-5" data-id="element-900">
                  <a href="/contact" className="bg-[#2C2416] text-[#FAF7F2] px-9 py-[18px] rounded-full font-medium tracking-[0.5px] hover:scale-105 transition-all duration-300 hover:bg-[#D4A574] font-['Inter']" data-id="element-901">
                    Start Your Project
                  </a>
                </div>
              </div>
              <div className="bg-white flex items-center justify-center min-h-[400px] md:min-h-[600px] overflow-hidden" data-id="element-902">
                <div className="aspect-[4/3] bg-gradient-to-br from-[#D4A574] to-[#E8C4A0] flex items-center justify-center w-full h-full relative overflow-hidden" data-id="element-903">
                  <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-904">
                    {/* Hero: Abstract Wine Bottle & Glass */}
                    <defs data-id="element-905">
                      <linearGradient id="wineGrad" x1="0%" y1="0%" x2="100%" y2="100%" data-id="element-906">
                        <stop offset="0%" style={{
                        stopColor: '#FAF7F2',
                        stopOpacity: 0.2
                      }} data-id="element-907" />
                        <stop offset="100%" style={{
                        stopColor: '#2C2416',
                        stopOpacity: 0.1
                      }} data-id="element-908" />
                      </linearGradient>
                    </defs>

                    {/* Background Texture */}
                    <rect width="100%" height="100%" fill="url(#wineGrad)" data-id="element-909" />

                    <g transform="translate(200, 150)" data-id="element-910">
                      {/* Abstract Bottle Shape */}
                      <path d="M -40 80 L -40 -20 Q -40 -60 -20 -80 L -20 -100 L 20 -100 L 20 -80 Q 40 -60 40 -20 L 40 80 Z" fill="none" stroke="#2C2416" strokeWidth="2" opacity="0.3" data-id="element-911" />
                      <path d="M -30 70 L -30 -15 Q -30 -50 -15 -65 L -15 -90 L 15 -90 L 15 -65 Q 30 -50 30 -15 L 30 70 Z" fill="#2C2416" opacity="0.05" data-id="element-912" />

                      {/* Wine Glass Shape */}
                      <path d="M 60 20 Q 60 60 90 60 Q 120 60 120 20 L 120 0 L 60 0 Z" fill="none" stroke="#2C2416" strokeWidth="2" opacity="0.3" data-id="element-913" />
                      <line x1="90" y1="60" x2="90" y2="100" stroke="#2C2416" strokeWidth="2" opacity="0.3" data-id="element-914" />
                      <line x1="70" y1="100" x2="110" y2="100" stroke="#2C2416" strokeWidth="2" opacity="0.3" data-id="element-915" />

                      {/* Liquid Level */}
                      <path d="M -35 40 Q 0 50 35 40 L 35 80 L -35 80 Z" fill="#2C2416" opacity="0.1" data-id="element-916" />
                      <path d="M 65 30 Q 90 40 115 30 L 118 20 L 62 20 Z" fill="#2C2416" opacity="0.1" data-id="element-917" />

                      {/* Decorative Circles */}
                      <circle cx="-60" cy="-40" r="40" fill="none" stroke="#FAF7F2" strokeWidth="1" opacity="0.2" data-id="element-918" />
                      <circle cx="100" cy="-60" r="20" fill="#FAF7F2" opacity="0.2" data-id="element-919" />
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Wine Ecommerce Expertise */}
      <section id="cro" className="service-section py-24 bg-[#FAF7F2] scroll-mt-36 px-10" data-id="element-920">
        <div className="max-w-[1400px] mx-auto" data-id="element-921">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-922">
            <div data-id="element-923">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-924">
                Wine Ecommerce Expertise
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-925">
                We understand how wineries operate and how customers interact
                with winery websites. Over 100 heat map tests have shown us
                exactly how users navigate - where they look first, what they
                miss, and what drives them to book, buy, or join.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-926">
                {['Tested on real winery customer behaviour', 'User flow optimised for wine club signups', 'Cellar door and event bookings made easy', 'Intuitive customer portals and account areas', 'Products and shop positioned for conversion', 'Nothing buried in menus'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-927">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-928">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-929">
              <div className="aspect-[4/3] bg-gradient-to-br from-[#D4A574] to-[#E8C4A0] flex items-center justify-center relative overflow-hidden" data-id="element-930">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-931">
                  {/* Expertise: Growth & Analytics */}
                  <g transform="translate(200, 150)" data-id="element-932">
                    {/* Grid Lines */}
                    <line x1="-150" y1="50" x2="150" y2="50" stroke="#2C2416" strokeWidth="1" opacity="0.1" data-id="element-933" />
                    <line x1="-150" y1="0" x2="150" y2="0" stroke="#2C2416" strokeWidth="1" opacity="0.1" data-id="element-934" />
                    <line x1="-150" y1="-50" x2="150" y2="-50" stroke="#2C2416" strokeWidth="1" opacity="0.1" data-id="element-935" />

                    {/* Growth Curve */}
                    <path d="M -120 50 Q -60 50 0 0 T 120 -80" fill="none" stroke="#2C2416" strokeWidth="3" opacity="0.4" data-id="element-936" />

                    {/* Bars */}
                    <rect x="-100" y="10" width="30" height="40" fill="#FAF7F2" opacity="0.3" data-id="element-937" />
                    <rect x="-40" y="-20" width="30" height="70" fill="#FAF7F2" opacity="0.4" data-id="element-938" />
                    <rect x="20" y="-50" width="30" height="100" fill="#FAF7F2" opacity="0.5" data-id="element-939" />
                    <rect x="80" y="-90" width="30" height="140" fill="#FAF7F2" opacity="0.6" data-id="element-940" />

                    {/* Data Points */}
                    <circle cx="-120" cy="50" r="4" fill="#2C2416" opacity="0.6" data-id="element-941" />
                    <circle cx="0" cy="0" r="4" fill="#2C2416" opacity="0.6" data-id="element-942" />
                    <circle cx="120" cy="-80" r="4" fill="#2C2416" opacity="0.6" data-id="element-943" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Experience-Driven Design */}
      <section id="ab-testing" className="service-section py-24 bg-white scroll-mt-36 px-10" data-id="element-944">
        <div className="max-w-[1400px] mx-auto" data-id="element-945">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-946">
            <div className="md:order-2" data-id="element-947">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-948">
                Experience-Driven Design
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-949">
                Winery websites need to make people feel something. We use
                emotive imagery and intuitive design to connect users with your
                brand - your cellar door, your wines, your story. Fast, secure,
                and built to perform.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-950">
                {['Emotive imagery that connects to your brand', 'Cellar door, restaurant, and events showcased', 'Intuitive navigation and layout', 'Mobile-first responsive design', 'Fast load times and performance optimised', 'Secure and reliable'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-951">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-952">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg md:order-1" data-id="element-953">
              <div className="aspect-[4/3] bg-gradient-to-br from-[#D4A574] to-[#E8C4A0] flex items-center justify-center relative overflow-hidden" data-id="element-954">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-955">
                  {/* Experience Design: Frames & Layers */}
                  <g transform="translate(200, 150)" data-id="element-956">
                    {/* Background Frame */}
                    <rect x="-100" y="-80" width="160" height="120" fill="#FAF7F2" opacity="0.3" stroke="#2C2416" strokeWidth="1" data-id="element-957" />

                    {/* Middle Frame */}
                    <rect x="-80" y="-60" width="160" height="120" fill="#FAF7F2" opacity="0.5" stroke="#2C2416" strokeWidth="1" data-id="element-958" />

                    {/* Front Frame */}
                    <rect x="-60" y="-40" width="160" height="120" fill="#FAF7F2" opacity="0.8" stroke="#2C2416" strokeWidth="2" data-id="element-959" />

                    {/* Design Elements */}
                    <circle cx="-20" cy="-10" r="15" fill="#2C2416" opacity="0.1" data-id="element-960" />
                    <rect x="10" y="-20" width="60" height="5" fill="#2C2416" opacity="0.1" data-id="element-961" />
                    <rect x="10" y="-5" width="40" height="5" fill="#2C2416" opacity="0.1" data-id="element-962" />

                    {/* Interactive Touch Point */}
                    <circle cx="60" cy="40" r="8" fill="none" stroke="#2C2416" strokeWidth="2" opacity="0.4" data-id="element-963" />
                    <circle cx="60" cy="40" r="4" fill="#2C2416" opacity="0.4" data-id="element-964" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Wine Club & Loyalty */}
      <section id="analytics-tracking" className="service-section py-24 bg-[#FAF7F2] scroll-mt-36 px-10" data-id="element-965">
        <div className="max-w-[1400px] mx-auto" data-id="element-966">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-967">
            <div data-id="element-968">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-969">
                Wine Club & Loyalty
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-970">
                We've built wine clubs across WinePik, Commerce7, WineHub, and
                Shopify. We know which setups convert - tiered memberships,
                allocation models, flexible subscriptions. Loyalty programs
                running alongside or standalone.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-971">
                {['Wine club setup and configuration', 'Membership models that convert', 'Tiered, allocation, and flexible structures', 'Loyalty program setup', 'Points, rewards, and member perks', 'Run alongside wine club or standalone'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-972">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-973">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg" data-id="element-974">
              <div className="aspect-[4/3] bg-gradient-to-br from-[#D4A574] to-[#E8C4A0] flex items-center justify-center relative overflow-hidden" data-id="element-975">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-976">
                  {/* Wine Club: Connected Tiers */}
                  <g transform="translate(200, 150)" data-id="element-977">
                    {/* Central Hub */}
                    <circle cx="0" cy="0" r="30" fill="#FAF7F2" opacity="0.8" data-id="element-978" />
                    <circle cx="0" cy="0" r="30" fill="none" stroke="#2C2416" strokeWidth="2" data-id="element-979" />
                    <path d="M -10 5 L 0 -10 L 10 5 Z" fill="#2C2416" opacity="0.4" data-id="element-980" />

                    {/* Tier 1 Nodes */}
                    <circle cx="0" cy="-80" r="15" fill="#FAF7F2" opacity="0.6" data-id="element-981" />
                    <circle cx="0" cy="-80" r="15" fill="none" stroke="#2C2416" strokeWidth="1.5" data-id="element-982" />

                    <circle cx="70" cy="40" r="15" fill="#FAF7F2" opacity="0.6" data-id="element-983" />
                    <circle cx="70" cy="40" r="15" fill="none" stroke="#2C2416" strokeWidth="1.5" data-id="element-984" />

                    <circle cx="-70" cy="40" r="15" fill="#FAF7F2" opacity="0.6" data-id="element-985" />
                    <circle cx="-70" cy="40" r="15" fill="none" stroke="#2C2416" strokeWidth="1.5" data-id="element-986" />

                    {/* Connections */}
                    <line x1="0" y1="-30" x2="0" y2="-65" stroke="#2C2416" strokeWidth="1" opacity="0.4" data-id="element-987" />
                    <line x1="25" y1="15" x2="58" y2="32" stroke="#2C2416" strokeWidth="1" opacity="0.4" data-id="element-988" />
                    <line x1="-25" y1="15" x2="-58" y2="32" stroke="#2C2416" strokeWidth="1" opacity="0.4" data-id="element-989" />

                    {/* Outer Orbit */}
                    <circle cx="0" cy="0" r="100" fill="none" stroke="#2C2416" strokeWidth="0.5" strokeDasharray="4 4" opacity="0.2" data-id="element-990" />
                    <circle cx="100" cy="0" r="4" fill="#2C2416" opacity="0.4" data-id="element-991" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Email */}
      <section id="performance-optimisation" className="service-section py-24 bg-white scroll-mt-36 px-10" data-id="element-992">
        <div className="max-w-[1400px] mx-auto" data-id="element-993">
          <div className="grid md:grid-cols-2 gap-20 items-center" data-id="element-994">
            <div className="md:order-2" data-id="element-995">
              <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-6 font-['Inter']" data-id="element-996">
                Email
              </h2>
              <p className="text-[#8B7355] text-lg mb-8 leading-relaxed font-['Inter']" data-id="element-997">
                Klaviyo setup and strategy for wineries. Welcome sequences,
                shipment reminders, member exclusives, re-engagement flows -
                built around how wine club members actually buy.
              </p>
              <ul className="mb-10 space-y-4" data-id="element-998">
                {['Klaviyo setup and migration', 'Automated flows for wine club members', 'Shipment and renewal reminders', 'New release and allocation announcements', 'Re-engagement and win-back sequences', 'Campaign strategy and templates'].map((item, index) => <li key={index} className="flex items-start text-[#8B7355] font-['Inter'] pl-8 relative" data-id="element-999">
                    <span className="text-[#D4A574] absolute left-0 font-semibold" data-id="element-1000">
                      ✓
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="bg-white rounded-2xl overflow-hidden shadow-lg md:order-1" data-id="element-1001">
              <div className="aspect-[4/3] bg-gradient-to-br from-[#D4A574] to-[#E8C4A0] flex items-center justify-center relative overflow-hidden" data-id="element-1002">
                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 400 300" preserveAspectRatio="xMidYMid slice" data-id="element-1003">
                  {/* Email: Communication Ripples */}
                  <g transform="translate(200, 150)" data-id="element-1004">
                    {/* Center Point */}
                    <circle cx="0" cy="0" r="4" fill="#2C2416" opacity="0.8" data-id="element-1005" />

                    {/* Ripples */}
                    <circle cx="0" cy="0" r="20" fill="none" stroke="#2C2416" strokeWidth="1.5" opacity="0.6" data-id="element-1006" />
                    <circle cx="0" cy="0" r="40" fill="none" stroke="#2C2416" strokeWidth="1" opacity="0.4" data-id="element-1007" />
                    <circle cx="0" cy="0" r="60" fill="none" stroke="#2C2416" strokeWidth="0.5" opacity="0.2" data-id="element-1008" />
                    <circle cx="0" cy="0" r="80" fill="none" stroke="#2C2416" strokeWidth="0.25" opacity="0.1" data-id="element-1009" />

                    {/* Message Icons */}
                    <rect x="30" y="-40" width="20" height="14" rx="2" fill="#FAF7F2" stroke="#2C2416" strokeWidth="1" data-id="element-1010" />
                    <rect x="-50" y="20" width="20" height="14" rx="2" fill="#FAF7F2" stroke="#2C2416" strokeWidth="1" data-id="element-1011" />
                    <rect x="40" y="50" width="20" height="14" rx="2" fill="#FAF7F2" stroke="#2C2416" strokeWidth="1" data-id="element-1012" />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Features Grid */}
      <section className="py-24 bg-white px-10" data-id="element-1013">
        <div className="max-w-[1400px] mx-auto" data-id="element-1014">
          <div className="text-center mb-20" data-id="element-1015">
            <h2 className="text-[#2C2416] text-[clamp(36px,5vw,48px)] font-light tracking-[-2px] mb-5 font-['Inter']" data-id="element-1016">
              Why Wineries Work With Us
            </h2>
            <p className="text-[#8B7355] text-lg font-['Inter']" data-id="element-1017">
              15 years of wine ecommerce experience behind every project
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1018">
            {[{
            title: '15 Years in Wine',
            description: "We've been building winery websites since before most platforms existed. That experience shows in the decisions we make."
          }, {
            title: '100+ Heat Map Tests',
            description: 'Real data on how winery customers behave. We design based on what actually works, not assumptions.'
          }, {
            title: 'Platform Agnostic',
            description: "WinePik, Commerce7, WineHub, Shopify - we recommend what fits your winery, not what's easiest for us."
          }, {
            title: 'Wine Club Experts',
            description: 'We know which membership models convert and which ones churn. Setup, strategy, and optimisation.'
          }, {
            title: 'We Stick Around',
            description: "Long-term partnerships, not project handoffs. We're here after launch when you need us."
          }, {
            title: 'Faster Iterations',
            description: 'Modern tools mean more design options, quicker decisions, and lower costs. No endless back-and-forth.'
          }].map((feature, index) => <motion.div key={index} className="bg-[#FAF7F2] p-8 rounded-xl border border-[#D4A57420] transition-all duration-300 hover:shadow-xl hover:-translate-y-1" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-1019">
                <h4 className="text-[#2C2416] text-xl font-medium mb-4 font-['Inter']" data-id="element-1020">
                  {feature.title}
                </h4>
                <p className="text-[#8B7355] font-['Inter'] text-[15px] leading-relaxed" data-id="element-1021">
                  {feature.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-12 md:py-20 px-5 md:px-10" data-id="element-1022">
        <div className="max-w-[1400px] mx-auto" data-id="element-1023">
          <div className="bg-[#2C2416] text-center p-8 md:p-16 lg:p-24 rounded-3xl" data-id="element-1024">
            <h2 className="text-[#FAF7F2] text-[clamp(32px,6vw,48px)] font-light tracking-[-2px] mb-4 md:mb-6 font-['Inter']" data-id="element-1025">
              Let's Build Your Winery Website
            </h2>
            <p className="text-[#D4A574] text-lg md:text-xl max-w-2xl mx-auto mb-8 md:mb-12 font-['Inter'] leading-relaxed" data-id="element-1026">
              New build, migration, wine club setup, or email - we're here to
              help.
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-4 md:gap-5" data-id="element-1027">
              <a href="/contact" className="bg-[#D4A574] text-[#2C2416] px-9 py-[18px] rounded-full font-medium tracking-[0.5px] hover:scale-105 transition-all duration-300 hover:bg-[#FAF7F2] font-['Inter']" data-id="element-1028">
                Start Your Project
              </a>
            </div>
          </div>
        </div>
      </section>
      <Footer data-id="element-1029" />
    </div>;
}